import { rootApi } from '../rootApi';

export const claimHistoryReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({          // ← endpoints başlıyor
        getClaimHistoryReport: builder.query({
            query: (body) => ({
                url: 'v1/warrantyhistoryreport/getlist',
                method: 'POST',
                body: {
                    pageSize:   body.pageSize   ?? 20,
                    pageNumber: body.pageNumber  ?? 1,
                    filters:    body.filters    ?? null,
                    sorts:      body.sorts      ?? null,
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items:         response.data.items,
                        totalCount:    response.data.totalCount    ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['ClaimHistoryReport']
        }),                              // ← getClaimHistoryReport bitti, VIRGÜL var
        exportClaimHistoryToExcel: builder.query({
            query: (body) => ({
                url: 'v1/warrantyhistoryreport/exporttoexcel',
                method: 'POST',
                body: {
                    filters:         body.filters         ?? null,
                    sorts:           body.sorts           ?? null,
                    LanguageId:      body.LanguageId,
                    compressionType: 0,
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export başarısız oldu');
            }
        })                               // ← exportClaimHistoryToExcel bitti
    }),                                  // ← endpoints kapandı
    overrideExisting: false
});

export const {
    useGetClaimHistoryReportQuery,
    useLazyExportClaimHistoryToExcelQuery
} = claimHistoryReportApi;